import _defineProperty from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import { styled, alpha } from '@mui/material/styles';
var DemoToolbarRoot = styled('div', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'demoOptions' && prop !== 'openDemoSource';
  }
})(function (_ref) {
  var theme = _ref.theme;
  return [_defineProperty(_defineProperty({
    display: 'none'
  }, theme.breakpoints.up('sm'), _extends({
    top: 0,
    maxHeight: 50,
    display: 'block',
    marginTop: -1,
    padding: theme.spacing('2px', 1),
    border: "1px solid ".concat((theme.vars || theme).palette.divider),
    borderTopWidth: 0,
    backgroundColor: alpha(theme.palette.grey[50], 0.2),
    borderRadius: '0 0 12px 12px',
    transition: theme.transitions.create('border-radius')
  }, theme.direction === 'rtl' && {
    left: theme.spacing(1)
  }, theme.direction !== 'rtl' && {
    right: theme.spacing(1)
  })), "variants", [{
    props: function props(_ref2) {
      var demoOptions = _ref2.demoOptions;
      return demoOptions.bg === 'inline';
    },
    style: _defineProperty({}, theme.breakpoints.up('sm'), {
      marginTop: theme.spacing(1),
      borderTopWidth: 1
    })
  }, {
    props: function props(_ref3) {
      var openDemoSource = _ref3.openDemoSource;
      return openDemoSource;
    },
    style: _defineProperty({}, theme.breakpoints.up('sm'), {
      borderRadius: 0
    })
  }]), theme.applyDarkStyles(_defineProperty({}, theme.breakpoints.up('sm'), {
    backgroundColor: alpha(theme.palette.primaryDark[800], 0.2)
  }))];
});
export default DemoToolbarRoot;